import React, { useState } from "react";
import PageHeaders from "../common/PageHeaders";
import Menu from "../common/Menu";
import Header from "../components/Header";
import Footer from "../components/Footer";
import StartYourTomorrow from "../components/StartYourTomorrow";
import BannerImage from "../images/link_bank_banner.webp";
import Bank1 from "../images/bank_capital_one.webp";
import Bank2 from "../images/bank_charles_schwab.webp";
import Bank4 from "../images/bank_fidelity.webp";
import Bank5 from "../images/bank_pnc.webp";
import Bank6 from "../images/bank_us_bank.webp";
import Bank7 from "../images/bank_robinhood.webp";
import Bank8 from "../images/bank_american_express.webp";
// import Bank9 from "images/bank_usaa.png";
// import Bank10 from "images/bank_citi.png";

const ApplicationTroubleshooting = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const banks = [
    {
      name: "Capital One",
      image: Bank1,
      status: "down"
    },
    {
      name: "Charles Schwab",
      image: Bank2,
      status: "intermittent"
    },
    // {
    //   name: "Chase",
    //   image: Bank3,
    //   status: "good"
    // },
    {
      name: "Fidelity",
      image: Bank4,
      status: "down"
    },
    {
      name: "PNC",
      image: Bank5,
      status: "intermittent"
    },
    {
      name: "US Bank",
      image: Bank6,
      status: "down"
    },
    {
      name: "Robinhood",
      image: Bank7,
      status: "down"
    },
    {
      name: "American Express",
      image: Bank8,
      status: "intermittent"
    },
    // {
    //   name: "USAA",
    //   image: Bank9,
    //   status: "intermittent"
    // },
    // {
    //   name: "Citi",
    //   image: Bank10,
    //   status: "intermittent"
    // }
  ];

  const titles = {
    intermittent: "Intermitent Issues",
    down: "Currently Down",
    good: "Good"
  };

  const descriptions = {
    intermittent:
      "This institution is having occasional problems connecting. Please keep trying over the next couple days.",
    down:
      "This institution cannot be connected at this time. Please check back later.",
    good: "Our connection with this institution is healthy "
  };

  const classes = {
    tooltipText: {
      intermittent: "text-orange-400 text-sm",
      down: "text-red-500 text-sm",
      good: "text-green-500 text-sm"
    }
  };

  const renderInstitution = ({ name, image, status }) => (
    <div class="w-full md:w-1/4">
      <div className="text-gray-700 text-center bg-white px-4 py-10 shadow-md rounded m-3">
        <img
          className="mx-auto w-1/3 p-3 border-solid border border-gray-200 rounded-full mb-5"
          src={image}
        ></img>
        <h5 className="font-bold text-xl">{name}</h5>
        <p className="font-bold text-sm text-gray-600 mt-3">Status:</p>
        <p className={classes.tooltipText[status]}>
          {`${titles[status]} `}
          <div class="tooltip text-gray-600 text-xs">
            <span>&#9432;</span>
            <span class="tooltiptext text-sm">{`${descriptions[status]}`}</span>
          </div>
        </p>
      </div>
    </div>
  );

  return (
    <>
      <PageHeaders type="comparison" />
      <div className="flex flex-col h-full" id="outer-container">
        <div className={`relative ${!!menuOpen ? "" : "max-w-page"}`}>
          <Menu
            handleToggle={state => {
              setMenuOpen(state.isOpen);
            }}
            hidden={menuOpen}
          />
        </div>
        <div className="mainContent xtopSection" id="page-wrap">
          <div className="headerBar">
            <Header siteTitle={"The card"} />
          </div>
          <div className="flex mt-24">
            <main className="w-full text-dark pt-4">
              <div className="mb-8 bannerBackground2">
                <div className="md:flex max-w-page items-center text-center md:text-left">
                  <div className="flex-1">
                    <div className="w-10/12 mx-auto">
                      <h1 className="text-4xl lg:text-5xl xl:text-6xl font-extrabold md:-mt-16 text-primary">
                        Application help
                        <span class="text-primary-txt">.</span>
                      </h1>
                      <p className="text-xl lg:text-xl xl:text-2xl my-4 text-white">
                        We're here to help you in whatever way we can.
                      </p>
                    </div>
                  </div>
                  <div className="lg:px-5 mx-auto pt-20 w-3/4 md:w-5/12">
                    <img className="mx-auto pb-10 md:pb-20" src={BannerImage} />
                  </div>
                </div>
              </div>

              <div className="max-w-page">
                <h3 className="text-center py-10 text-3xl font-bold text-primary">
                  <span className="text-primary-txt">Accepted</span> account
                  types
                </h3>
                <div class="flex">
                  <div class="flex-1 text-gray-700 text-center bg-white px-4 py-2 m-2 font-bold">
                    Checking Accounts
                  </div>
                  <div class="flex-1 text-gray-700 text-center bg-white px-4 py-2 m-2 font-bold">
                    Savings Accounts
                  </div>
                  <div class="flex-1 text-gray-700 text-center bg-white px-4 py-2 m-2 font-bold">
                    Asset Accounts
                  </div>
                </div>
              </div>

              <section className="bg-gray-100 my-20 py-20">
                <div className="max-w-page">
                  <div className=" w-10/12 md:w-7/12 mx-auto">
                    <h2 className="text-center pt-10 pb-1 text-3xl font-bold">
                      Institutions currently causing{" "}
                      <span class="text-red-400">trouble</span>
                    </h2>
                    <p className="text-center mb-10">
                      The institutions below are currently having linking
                      issues. Unfortunately, this is controlled by a 3rd party
                      and is out of our control. Please continue to check your
                      institution status here and keep trying to link your
                      account over the next few days.{" "}
                    </p>
                  </div>
                  <div class="flex flex-wrap px-5">
                    {banks.map(b => renderInstitution(b))}
                  </div>
                </div>
              </section>

              <div className="max-w-page mb-20 text-white">
                <h2 className="text-4xl xl:text-5xl font-extrabold p-8 xl:px-12">
                  FAQ's<span className="text-primary-txt">.</span>
                </h2>
                <div className="md:flex">
                  <div className="md:w-1/2 p-8 xl:px-12">
                    <h3 className="text-xl lg:text-2xl font-bold mb-4">
                      Are there other options if I cannot link my account?
                    </h3>
                    <p>
                      Unfortunately, at this time there is no other method of
                      linking unsupported institutions. We look to in the near
                      future though!
                    </p>
                  </div>
                  <div className="md:w-1/2 p-8 xl:px-12">
                    <h3 className="text-xl lg:text-2xl font-bold mb-4">
                      What if my bank does not show up on the list?
                    </h3>
                    <p>
                      Please try another institution or check back at a later
                      time. We look to support additional institutions in the
                      near future.
                    </p>
                  </div>
                </div>
                <div className="md:flex">
                  <div className="md:w-1/2 p-8 xl:px-12">
                    <h3 className="text-xl lg:text-2xl font-bold mb-4">
                      What types of accounts can I link?
                    </h3>
                    <p>
                      You can link anything from checkings, savings and even
                      asset/investment accounts.
                    </p>
                  </div>
                  <div className="md:w-1/2 p-8 xl:px-12">
                    <h3 className="text-xl lg:text-2xl font-bold mb-4">
                      How do I get a higher spending power?
                    </h3>
                    <p>
                      Link as many accounts as you can so your financial profile
                      is stronger!
                    </p>
                  </div>
                </div>
                <div className="md:flex">
                  <div className="md:w-1/2 p-8 xl:px-12">
                    <h3 className="text-xl lg:text-2xl font-bold mb-4">
                      What does "Invalid Credentials" error mean?
                    </h3>
                    <p>
                      It means the credentials you provided did not match what
                      your institution has on file. Please verify this info and
                      try again.
                    </p>
                  </div>
                </div>
              </div>

              <StartYourTomorrow />
            </main>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default ApplicationTroubleshooting;
